import "./ant.styles";

// tslint:disable-next-line:no-var-requires
require("./main.css");
